angular.module('elfium').filter('taskGetNearest', ['TASK_STATES', 
    function (TASK_STATES) {
        var that = this;
        that.isTaskOneBeforeTaskTwo = function (taskOne, taskTwo) {
            var now = new Date();
            var a = taskOne.termin - now.getTime();
            var b = taskTwo.termin - now.getTime();
            return ((a > 0 && b < 0) || (a < 0 && b < 0 && a > b) || (a > 0 && b > 0 && a < b));
        };
        return function (tasks) {
            var nearestTask = null;
            angular.forEach(tasks, function (task) {
                var taskHasProperState = task.stav != TASK_STATES.NESPLNENO;
                var shouldAssignAsNearestTask = (nearestTask == null || that.isTaskOneBeforeTaskTwo(task, nearestTask));
                if (taskHasProperState && shouldAssignAsNearestTask) {
                    nearestTask = task;
                }
            });
            return nearestTask;        
        };
    }
]);


// WEBPACK FOOTER //
// ./src/app/components/task/taskGetNearestFilter.ts